/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const HandClickingOutline = createIcon({
  displayName: 'HandClickingOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M12.706,13v-4.5c0,-0.828 -0.672,-1.5 -1.5,-1.5v0c-0.828,0 -1.5,0.672 -1.5,1.5v2.5v5l-2.032,-0.677c-0.593,-0.198 -1.247,-0.043 -1.69,0.399v0c-0.687,0.687 -0.635,1.814 0.11,2.436l4.055,3.379c0.361,0.299 0.814,0.463 1.281,0.463h4.51c1.009,0 1.859,-0.751 1.985,-1.752l0.543,-4.343c0.133,-1.065 -0.598,-2.044 -1.656,-2.221l-4.106,-0.684Z"></path>
        <path d="M5.21,8h1"></path>
        <path d="M17.21,8h-1"></path>
        <path d="M15.45,3.76l-0.71,0.7"></path>
        <path d="M6.96,3.76l0.71,0.7"></path>
        <path d="M11.21,2v1"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const HandClicking: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    default:
      return <CustomIcon as={HandClickingOutline} {...props} />
  }
}

export default memo(HandClicking)
